'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function FaceHappy(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2C4.67891 2 2 4.67891 2 8C2 11.3211 4.67891 14 8 14C11.3211 14 14 11.3211 14 8C14 4.67891 11.3211 2 8 2ZM8 3.28571C10.6311 3.28571 12.7143 5.36893 12.7143 8C12.7143 10.6311 10.6311 12.7143 8 12.7143C5.36893 12.7143 3.28571 10.6311 3.28571 8C3.28571 5.36893 5.36893 3.28571 8 3.28571Z", fill: "currentColor" }),
        React__default.default.createElement("circle", { cx: "10", cy: "7", r: "1", fill: "currentColor" }),
        React__default.default.createElement("path", { d: "M4.49984 9.5C4.21322 10.2263 5.43175 12 7.96585 12C10.4999 12 11.7749 10.2739 11.4999 9.50036C11.225 8.72678 10.4999 10.3262 7.96581 10.3262C5.4317 10.3262 4.78646 8.7737 4.49984 9.5Z", fill: "currentColor" }),
        React__default.default.createElement("circle", { cx: "6", cy: "7", r: "1", fill: "currentColor" })));
}

module.exports = FaceHappy;
//# sourceMappingURL=FaceHappy.js.map
